import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const SvgComponent = ({ size = 20, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M3.17 7.677a10.23 10.23 0 0 1 7.25-3.003v2.788A7.448 7.448 0 0 0 5.14 9.648L3.17 7.677Z"
        fill="#FECA57"
      />
      <Path
        d="m17.668 7.677-1.972 1.971a7.449 7.449 0 0 0-5.278-2.186V4.674c2.583 0 5.094.924 7.25 3.003Z"
        fill="#15BA8B"
      />
      <Path
        d="m17.668 7.677-1.972 1.971a7.449 7.449 0 0 0-5.278-2.186V4.674c2.583 0 5.094.924 7.25 3.003Z"
        fill="#15BA8B"
      />
      <Path
        d="M20.668 14.707a.185.185 0 0 1-.184.189h-2.42a.184.184 0 0 1-.184-.178 7.447 7.447 0 0 0-2.183-5.07l1.971-1.971a10.228 10.228 0 0 1 3 7.03Z"
        fill="#15BA8B"
      />
      <Path
        d="M16.398 7.598c-1.747-1.684-3.724-2.618-5.784-2.922 2.513.045 4.952.974 7.054 3l-.627.628c-.203-.244-.417-.48-.643-.706ZM19.244 14.896a.187.187 0 0 0 .187-.192c-.05-2.38-.91-4.62-2.39-6.4l.627-.627a10.228 10.228 0 0 1 3 7.03.185.185 0 0 1-.184.189h-2.42 1.18Z"
        fill="#11AA7B"
      />
      <Path
        d="M3.17 7.677 5.14 9.648a7.448 7.448 0 0 0-2.183 5.07.184.184 0 0 1-.184.178H.354a.185.185 0 0 1-.185-.19 10.235 10.235 0 0 1 3-7.03Z"
        fill="#FF6B6B"
      />
      <Path
        d="m8.822 11.26 4.845-1.498c.2-.062.389.126.327.327l-1.498 4.845c-.653 2.114-3.32 2.774-4.884 1.21-1.564-1.564-.904-4.231 1.21-4.884Z"
        fill="#15BA8B"
      />
      <Path
        d="M7.612 14.906c1.565 1.565 4.231.904 4.884-1.21l1.22-3.943a.261.261 0 0 1 .278.336l-1.498 4.845c-.653 2.114-3.32 2.774-4.884 1.21a2.91 2.91 0 0 1-.796-2.688c.113.523.373 1.027.796 1.45Z"
        fill="#11AA7B"
      />
      <Path
        d="M10.543 13.213a1.26 1.26 0 1 1-1.782 1.783 1.26 1.26 0 0 1 1.782-1.783Z"
        fill="#57ECC2"
      />
      <Path
        d="M10.744 13.474a1.261 1.261 0 1 1-2.184 0c.488.843 1.7.836 2.184 0Z"
        fill="#0F8964"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path
          fill="#fff"
          transform="matrix(-1 0 0 1 20.669 .75)"
          d="M0 0h20.5v20.5H0z"
        />
      </ClipPath>
    </Defs>
  </Svg>
)

export default SvgComponent
